import KmNewdialog from './main.vue'
KmNewdialog.install = function (vue) {
  vue.component(KmNewdialog.name, KmNewdialog)
}
export default KmNewdialog



// WEBPACK FOOTER //
// ./src/ui/components/km-newdialog/index.js